import { PreviewItemSetQuestion } from '@exam-management/qcontent-management';
import { Box, Dialog, type DialogProps, Flex } from '@shared/components';
import { useScrollIntoView } from '@shared/hooks';
import { useEffect } from 'react';

import { QuestionPreviewModalHeader } from '../question-preview-modal-header';

export interface ItemSetQuestionPreviewDialogProps {
  open: boolean;
  itemSetId: string;
  paragraph: string;
  question: string;
  questionId: string;
  choices: { label: string; order: number; isCorrect: boolean }[];
  totalQuestions: number;
  onClose: () => void;
  currentQuestionOrder?: number;
  footer?: JSX.Element;
  slotProps?: DialogProps['slotProps'];
}

export default function ItemSetQuestionPreviewDialog(
  props: Readonly<ItemSetQuestionPreviewDialogProps>,
) {
  const {
    open: isOpen,
    onClose,
    totalQuestions,
    itemSetId,
    paragraph,
    question,
    questionId,
    choices,
    currentQuestionOrder = 1,
    slotProps,
  } = props;

  const { scrollIntoView, targetRef, scrollableRef } = useScrollIntoView<HTMLDivElement>({
    duration: 0,
  });

  useEffect(() => {
    scrollIntoView();
  }, [currentQuestionOrder]);

  return (
    <Dialog
      fullScreen
      open={isOpen}
      onClose={onClose}
      slotProps={{
        paper: { ref: scrollableRef },
        ...slotProps,
      }}
    >
      {/* This div is used to scroll the content to top. */}
      <div ref={targetRef}></div>
      <QuestionPreviewModalHeader onBack={() => onClose?.()} />
      <Flex
        sx={(theme) => ({
          bgcolor: theme.palette.grey[50],
          p: theme.spacing(6),
          width: '100%',
          flex: 1,
        })}
      >
        <Flex
          sx={(theme) => ({
            p: theme.spacing(6),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: theme.spacing(6),
            borderRadius: theme.shape.rounded(4),
            boxShadow: theme.shadows[2],
            width: '100%',
            minHeight: '100%',
          })}
        >
          <Box sx={{ width: '100%', maxWidth: '800px' }}>
            <PreviewItemSetQuestion
              questionId={questionId}
              itemSetId={itemSetId}
              paragraph={paragraph}
              question={question}
              choices={choices}
              totalQuestions={totalQuestions}
            />
          </Box>
        </Flex>
      </Flex>
      <Box sx={{ position: 'sticky', bottom: 0 }}>{props.footer}</Box>
    </Dialog>
  );
}
